import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activate-etoll',
  templateUrl: './activate-e-toll.component.html',
  styles: []
})
export class ActivateETollComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
